
  import React, {  useEffect } from 'react';
  import moment from 'moment';
  import "moment/locale/es";
  
  const AsignDay = ({event}) => {
    //const [open, setModal] = useState(false);
    //const [durations] = useState([10, 20, 25, 30, 35, 40, 45, 50, 55, 60]);
    //const [duration, setDuration] = useState('');

    useEffect(()=>{
      
    },[]);


    return (<div>
              <div style={{display: 'flex', flexDirection: 'row' , width: '100%' }} onClick={(e)=>{
                //setModal(true);
              }}>
                <p style={{color: '#FFFFFF'}}>{event.title} {moment(event.start).format("hh:mm")} - {moment(event.end).format("hh:mm")} </p>
              </div>
              {/* open ?<Modal
                        open={open}
                        onClose={()=>{
                            setModal(false);
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >
                        <div className="paperAppointment-flex">
                            <p>{event.title}</p>
                            <p>{moment(event.start).format("hh:mm")} - {moment(event.end).format("hh:mm")}</p>
                            <p>{event.priority}</p>
                            <div style={{ display: 'flex' }}>
                                <FormControl className='formControlAgendaLeft'>
                                    <InputLabel id="demo-simple-select-label">Duración cita</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={duration}
                                    onChange={(event)=>{
                                        setDuration(event.target.value);
                                    }}
                                    defaultValue={''}
                                    >
                                    <MenuItem key={0} value={''}>Ninguno</MenuItem>
                                    {durations.map((duration, index)=> {
                                        return <MenuItem key={index} value={duration}>{duration}</MenuItem>
                                    })}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                                </Modal>:null*/}
            </div>)
  };

  export default AsignDay;